import type { Clients } from "@agrigate/rpc-clients";
import { getClients } from "@agrigate/rpc-clients";
import type { RPCMeta } from "@agrigate/shared/lib/rpc/clients";
import { isAuthFailure } from "@agrigate/shared/lib/utils/auth";
import { sessionAtom } from "@agrigate/shared-web-ui/lib/stores/session";
import { getRPC } from "@agrigate/shared-web-ui/lib/utils/rpc";
import { getDefaultStore } from "jotai";

console.log(`Using API_BASE=${API_BASE} for service registrations`);

export const getHeaders = async () => {
    const sessionState = getDefaultStore().get(sessionAtom);
    // const mTrackingId = await getTrackingId();
    const headers: Record<string, string> = {};
    if (sessionState?.token) {
        headers.Authorization = `Bearer ${sessionState.token}`;
    }
    // headers.agmtrackingid = mTrackingId;
    return headers;
};

export const handleError = (
    method: string,
    params: unknown[],
    meta: RPCMeta | undefined,
    error: unknown,
) => {
    console.error("RPC Request failed", error, { method, params, meta });
    if (isAuthFailure(error)) {
        console.log("Handling auth failure", error, meta);
        getDefaultStore().set(sessionAtom, null);
    }
};

const rpc: Clients = getClients(
    {
        backend: {
            url: API_BASE,
            getHeaders,
        },
        gateway: {
            url: API_GW_BASE,
            getHeaders,
        },
    },
    {
        onError: handleError,
    },
);

getRPC.override(() => () => rpc);

export default rpc;
